// RHFTimeInput.jsx

import React from "react";
import { TimeInput } from "@mantine/dates";
import { Controller, useFormContext } from "react-hook-form";

const RHFTimeInput = ({
  name,
  rules,
  defaultValue = "",
  withSeconds = false,
  hideError= false,
  onValueChange,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <TimeInput
          {...props}
          value={field.value ?? ""}
          placeholder="Time"
          
         style={{flex:1}}
          error={!hideError && error?.message}
          withSeconds={withSeconds}
          onChange={(event) => {
            const value = event.currentTarget.value;

            field.onChange(value);

            if (onValueChange) {
              onValueChange(value);
            }
          }}
        />
      )}
    />
  );
};

export default RHFTimeInput;